import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { cleanupContextualTools } from '@utils/contextual-tool-cleanup';

@Injectable()
export class LayersAPIService {
  constructor(private httpClient: HttpClient) {}

  getTileCards(rid) {
    rid = rid.replace('#', '');
    return this.httpClient.get(`/api/v1/cards/rids?rids=${rid}`);
  }
  apiPassthrough(endpoint, method, payload?: any) {
    const url = endpoint.startsWith('/') ? `/api/v1${endpoint}` : `/api/v1/${endpoint}`;
    return this.httpClient[method](url, payload);
  }

  getSidepanelDetails(rid, layer, mattermaps) {
    return this.httpClient
      .get(`/api/v1/info/${rid}?layer=${layer}&module=${mattermaps}&is_new_formschema=true`)
      .pipe(
        map((response: any) => {
          if (response?.contextualTools?.length) {
            response.contextualTools = cleanupContextualTools(response.contextualTools);
          }
          return response;
        })
      );
  }
}
